





































































































import Vue from 'vue';
import Component from 'vue-class-component';

import '@/globals';
import HomeOnBoardingCard from '@/components/home-on-boarding-card.vue';
import HomeNewsCard from '@/components/home-news-card.vue';
import HomeQuizCard from '@/components/home-quiz-card.vue';
import HomeCard from '@/components/home-card.vue';
import { HomeHelper } from '@/services/home-helper';
import { HomeContent, OnBoardingData, OnBoardingsState, NewsEntry, OnBoardingProgress } from '@/models/home';
import { LANGUAGE } from '../models/settings';
import { delay } from '@/utils';
import FavoriteHelper from '../services/favorite-helper';

@Component({
    components: { HomeCard, HomeNewsCard, HomeOnBoardingCard, HomeQuizCard }
})
export default class HomePage extends Vue {

    public onBoardingData: OnBoardingData = null;
    public onBoardingProgress: OnBoardingProgress = null;

    public newsEntry: NewsEntry = null;
    public homeContent: HomeContent = null;
    public showQuizCard = false;

    public isLoading = false;
    public isLoadingNews = false;

    public async onAppearing() {

        // wait for store content update
        if (!this.$store.isReady) {
            // first start
            this.isLoading = true;
            this.isLoadingNews = true;
            await this.$store.waitUntilReady();
        }

        // set local reference
        this.homeContent = this.$store.homeContent;

        // update onboarding state (kann man noch schoener schreiben)
        await HomeHelper.IncrementOnBoardingState(this.$store);
        this.onBoardingProgress = HomeHelper.GetOnBoardingProgress(this.$store);
        this.onBoardingData = HomeHelper.GetOnBoardingData(this.$store);

        // update favorits
        HomeHelper.UpdateHasFavorites(this.$store, this.$store.homeContent);

        // update quiz card
        this.showQuizCard = this.$store.quiz && process.env.VUE_APP_QUIZ === 'enabled';
        const quizCard = this.$refs.quizCard as HomeQuizCard;
        if (quizCard && quizCard.update) quizCard.update();

        // loading finished
        this.isLoading = false;

        // update news if not loaded
        const lang = this.$store.settings.language;
        if (navigator.onLine && !this.$store.newsEntry) {
            try {
                this.isLoadingNews = true;
                this.$store.newsEntry = await this.$store.api.getNews(lang);
            } catch (error) {
                console.error(error);
                this.$store.newsEntry = null;
            }
        }

        // set local reference
        this.newsEntry = this.$store.newsEntry;
        this.isLoadingNews = false;
    }

    public async onAppeared() {
        await this.fixScrollLock();
    }

    public async fixScrollLock() {
        this.$$('.page-content').addClass('reanimate-me');
        setTimeout(() => this.$$('.page-content').removeClass('reanimate-me'), 50);
    }

    public openRoutes() {
        this.$f7router.navigate('/routes/');
    }

    public openPois() {
        FavoriteHelper.RemoveFavoritFilterIfAny(this.$store);
        this.$f7router.navigate('/pois/');
    }

    public openArPois() {
        this.$f7router.navigate('/arlauncher/');
    }

    public openFavorites() {
        FavoriteHelper.AppendFavoritFilterIfNone(this.$store);
        this.$f7router.navigate('/pois/');
    }
}
